import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RouterModule } from '@angular/router';

import { SharedComponent } from './component/shared/shared.component';
import { AvatarComponent } from './component/avatar/avatar.component';
import { ClickOutsideDirective } from './directives/click-outside.directive';

const SHARED_COMPONENT = [SharedComponent];
const SHARED_MATERIAL_MODULES = [MatSnackBarModule];

@NgModule({
  declarations: [...SHARED_COMPONENT, ClickOutsideDirective],
  imports: [RouterModule, HttpClientModule, AvatarComponent, ...SHARED_MATERIAL_MODULES],
  exports: [RouterModule, ...SHARED_COMPONENT, AvatarComponent, ...SHARED_MATERIAL_MODULES],
})
export class SharedModule {}
